module.exports = __webpack_public_path__ + "img/wf4.f4280803.png";